Ext.define('SA.data.mixin.Filterable', {
    filterable: true,

    addFilterNullChecks(filter) {
        if (Array.isArray(filter)) {
            if (filter[0] === 'and' || filter[0] === 'or') {
                filter = filter.map(this.addFilterNullChecks, this);
            }
            else {
                filter = ['and', filter, ['<>', filter[1], null]];
            }
        }

        return filter;
    },

    auditFilter() {
        if (!this.isFilterAllowed(this.getFilter())) {
            this.setFilter(null);
        }
    },

    extractFilterAttributes(filter) {
        var fields = {};

        if (!filter || filter.length < 2) {
            return [];
        }

        gatherFields(filter);

        return Object.keys(fields);

        function gatherFields(filter) {
            if (filter[0] === 'and' || filter[0] === 'or') {
                filter.slice(1).forEach(gatherFields);
            }
            else {
                fields[filter[1]] = true;
            }
        }
    },

    getFilter() {
        return this.data.filter;
    },

    getFilterableAttributes() {
        return this.getAttributes();
    },

    getFilterQuery() {
        var filter = this.getFilter();

        if (!filter || filter.length < 2) {
            return null;
        }

        if (filter.length === 2) {
            filter = filter[1];
        }

        return this.addFilterNullChecks(filter);
    },

    getFilterVisibility() {
        return this.data.filterVisibility;
    },

    isFilterAllowed(filter) {
        var allowed = this.getFilterableAttributes(),
            used = this.extractFilterAttributes(filter);

        return used.every(attribute => allowed.includes(attribute));
    },

    isFiltered() {
        return this.getFilterVisibility() !== 'disable' && this.getFilterQuery();
    },

    setFilter(filter) {


                if (this.setFilterImpl(filter)) {
            this.fireEvent('change:filter');
        }
    },

    setFilterImpl(filter) {
        return this.set('filter', filter);
    },

    setFilterVisibility(visibility) {
        if (this.setFilterVisibilityImpl(visibility)) {
            this.fireEvent('change:filterVisibility');
        }
    },

    setFilterVisibilityImpl(visibility) {
        return this.set('filterVisibility', visibility);
    }
});
